export const zIndices = {
    spotlightOverlay: 1550,
    spotlight: 1560
};
